export default __webpack_public_path__ + "static/banner-four-shape9-1b1041156ba170a4c313c98a3bd8aeef.png";